// import {useShowContext} from 'ra-core';
import Spinner from '@/components/basic/Spinner';
import useMyResourceParams from '@/hooks/refinedev/useMyResourceParams';
import {defaultQueryOptions} from '@/pages/_utils';
import {Tabs, TabsContent, TabsList, TabsTrigger} from '@/shadcn_components/ui/tabs';
import {useShow} from '@refinedev/core';
// import ShowPage from 'pages/_shared/show-page';
import ConversationView from '../conversations/conversation-view';
import DocumentList from '../documents/document-list';
import ProjectNotes from './project-personal-notes';
import ProjectContractList from '../project_contracts/project_contract-list';
import {useSetCustomBreadcrumb} from '@/hooks/useBreadcrumbs';
import {EditButtonWorkflow} from './components/buttons';
import TaskListInProject from './task-list-in-project';
import ProjectOverview from './components/project-overview';
import {UserIconList} from '@/pages/_shared/user-icon-list';

// import {useBreadcrumbStore, useUpdateLastBreadcrumb} from '@/hooks/useBreadcrumbs';

const thisResource = 'projects';
import {useSearchParams} from 'react-router-dom';

const ProjectShow = () => {
  const resParams = useMyResourceParams();
  const [searchParams] = useSearchParams();
  const defaultTab = searchParams.get('tab') || 'general_info'; // Lấy tab từ URL

  const handleTabChange = (tab: string) => {
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set('tab', tab);
    window.history.replaceState({}, '', currentUrl.toString()); // Cập nhật URL mà không reload
  };

  const {query} = useShow({
    queryOptions: {
      ...defaultQueryOptions,
    },
    errorNotification: false,
    meta: {
      with: ['tasks', 'members'],
      append: ['task_status_summary', 'contract_status_summary'],
    },
  });

  const {data, isFetching, error, isError} = query;
  const record = data?.data;

  useSetCustomBreadcrumb(record?.name);

  if (!resParams.id) return <p>Đường dẫn không hợp lệ</p>;

  if (isFetching) {
    return <Spinner />;
  }

  if (isError) {
    return <p>{error?.data?.message || 'Đã có lỗi xảy ra'}</p>;
  }

  if (!record) {
    return <p>Không tìm thấy thông tin</p>;
  }

  return (
    <div className="px-2 h-full">
      <div className="flex flex-row h-16">
        <div className="flex flex-col">
          <p className="text-lg font-semibold">{record.name}</p>
          <p className="text-xs">{record.description}</p>
        </div>
        <div className="flex items-center">
          <UserIconList users={record.members} />
        </div>
      </div>

      <Tabs
        defaultValue={defaultTab}
        onValueChange={handleTabChange}
        className="h-[calc(100%-4rem)]">
        <TabsList className="flex gap-x-4 h-12">
          <TabsTrigger value="general_info">Thông tin chung</TabsTrigger>
          <TabsTrigger value="tasks">Công việc</TabsTrigger>
          <TabsTrigger value="documents">Tài liệu</TabsTrigger>
          <TabsTrigger value="conversations">Trao đổi</TabsTrigger>
          <TabsTrigger value="project-contracts">Hợp đồng</TabsTrigger>
          <TabsTrigger value="personal_notes">Ghi chú cá nhân</TabsTrigger>
          <EditButtonWorkflow
            id={String(resParams.id)}
            resource={thisResource}
            canParams={{
              my_role: record?.my_role,
            }}
          />
        </TabsList>

        <div className="h-[calc(100%-3rem)]">
          <TabsContent value="general_info" forceMount>
            <ProjectOverview project={record} />
          </TabsContent>

          <TabsContent value="tasks" forceMount>
            <TaskListInProject project={record} />
          </TabsContent>

          <TabsContent value="documents" forceMount>
            <DocumentList mediable_type="project" mediable_id={resParams.id} />
          </TabsContent>

          <TabsContent value="conversations" forceMount className="h-full">
            <ConversationView owner_type="project" owner_id={resParams.id} />
          </TabsContent>

          <TabsContent value="project-contracts" forceMount>
            <ProjectContractList project={record} />
          </TabsContent>

          <TabsContent value="personal_notes" forceMount>
            <ProjectNotes />
          </TabsContent>
        </div>
      </Tabs>
    </div>
  );
};

export default ProjectShow;
